import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from 'src/app/core/app-config.service';
import { DataService } from 'src/app/core/data.service';
import { Queue } from '../models/queue';
@Injectable({
  providedIn: "root",
})
export class QueueDataService extends DataService<Queue> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "Queues", acs, false);
  } 
}

  // delete(Id: number) {
  //   const url = `${environment.serviceBusApiRoot}api/${this.resourceName}/${Id}`;
  //   return this.http.delete(url);
  // }
  // create(value: T) {
  //   return this.http.post<T>(
  //     `${environment.configurationApiRoot}odata/${this.resourceName}/`,
  //     value
  //   );
  // }
  // update(dataItem: T, isNew: boolean = false) {
  //   if (!isNew) {
  //     const url = `${environment.configurationApiRoot}odata/${this.resourceName}/${dataItem.Id}`;
  //     return this.http.put(url, dataItem);
  //   } else {
  //     return this.create(dataItem);
  //   }
  // }

/*   create(value: Message[], queue: string) {
    return this.http.post<Message>(
      `${this.acs.current.serviceBusApiUrl}api/queues/${queue}`,
      value
    );
  }

  get(state: State, queue: string) {
    const url = `${this.acs.current.serviceBusApiUrl}api/queues/${queue}?top=${state.take}&skip=${state.skip}`;
    return this.http.get<Message[]>(url).pipe(
      switchMap((response) => {
        const gridResult: GridDataResult = {
          // data: [...response],
          data: [...response],
          total: 200,
          // total: response["@odata.count"],
        };
        return of(gridResult);
      })
    ); */
